import React from "react"
import classNames from "classnames"

export default function BulmaColumns(props) {
  var columnsClasses = classNames("columns", props.className, {})

  return <div className={columnsClasses}>{props.children}</div>
}
